/**
 * External dependencies
 */
import React from 'react';
import page from 'page';

/**
 * Internal dependencies
 */
import BuilderComponent from './main';
import { startEditingReport } from 'state/ui/report-builder/actions';
import { getReport, getEditedReport } from 'state/reports/selectors';

export const editReportBuilder = (context, next) => {
	const reportId = context.params.reportId;
	const state = context.store.getState();

	const report = getReport(state, reportId);

	if (report) {
		context.store.dispatch(startEditingReport(reportId));
	} else {
		page.redirect(`/report-builder/new`);
	}

	context.primary = <BuilderComponent reportId={reportId} report={report} />;
	next();
};

export const newReportBuilder = (context, next) => {
	// check the state for any existing edited
	// its up to the report builder to clear this from memory
	const state = context.store.getState();
	const report = getEditedReport(state, null) || {};

	context.store.dispatch(startEditingReport(null, report));
	context.primary = <BuilderComponent report={report} />;
	next();
};
